import React, { memo, useCallback, useRef } from 'react'
import { makeStyles } from '@material-ui/styles'
import Grid from '@material-ui/core/Grid'
import Fab from '@material-ui/core/Fab'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import AddIcon from '@material-ui/icons/Add'
import classNames from 'classnames'
import { useRouteMatch, useParams, useHistory } from 'react-router-dom'
import { useTranslation, Trans } from 'react-i18next'
import Hidden from '@material-ui/core/Hidden'
import { Helmet } from 'react-helmet'

import { Banner, FeedArticleList } from './components'
import { Read } from 'components'
import { useOnScreen } from 'utils'
import styles from './styles'
import { TIndexProps } from 'models'
import appLogo from 'assets/images/logo.svg'

const useStyles = makeStyles(styles)

const Index: React.FunctionComponent<TIndexProps> = props => {
	const classes = useStyles()
	const history = useHistory()
	const { articleSlug, postId }: { articleSlug?: string; postId: string } =
		useParams()
	const { t, i18n } = useTranslation()
	const createButtontRef = useRef(null)
	const onScreen = useOnScreen(createButtontRef, '-100px')
	const isMobile = useMediaQuery('@media (max-width:650px)')

	let match = useRouteMatch({
		path: '/:language(en|ro)',
		strict: true,
		sensitive: true,
	})

	const goToCreate = useCallback(() => {
		history.push({
			pathname: `/${i18n.language}/create`,
			state: {
				reset: true,
			},
		})
	}, [history, i18n.language])

	const createPostStyle: any =
		!onScreen && !isMobile
			? {
					position: 'fixed',
					bottom: '15px',
					top: 'auto',
					right: '15px',
					zIndex: '1',
			  }
			: {}

	return (
		<>
			{/* here I used 'match' to prevent those meta tags to be on the same page with meta tags from children component */}
			{match && match.isExact && (
				<Helmet>
					<meta
						property="og:title"
						content={'CV30 - Make Mondays happy!'}
					/>
					<meta property="og:url" content={window.location.href} />
					<meta property="og:image" content={appLogo} />
				</Helmet>
			)}
			{(articleSlug || postId) && <Read />}
			<Grid
				container
				justifyContent="center"
				className={classNames(classes.flexGrow, classes.paddingBottom)}
			>
				<Grid
					item
					xs={12}
					sm={8}
					md={6}
					lg={4}
					className={classNames(
						classes.minWidth,
						classes.contentContainer,
					)}
				>
					<Banner />
					<div
						ref={createButtontRef}
						className={classNames(
							classes.headline,
							classes.fontSize24,
						)}
					>
						<div>
							<Trans i18nKey="whatsnew">
								What's
								<strong>new?</strong>
							</Trans>
						</div>
						<Fab
							onClick={goToCreate}
							variant="extended"
							size="medium"
							color="primary"
							aria-label="Add"
							className={classes.createButton}
							style={createPostStyle}
						>
							<AddIcon className={classes.createButtonIcon} />
							<Hidden xsDown>{t('Create post')}</Hidden>
						</Fab>
					</div>
					<div
						className={classNames(
							classes.tagline,
							classes.fontSize12,
						)}
					>
						{t(
							`Meet the teams of top employers, see how they work daily, engage with people alike through content of interest, all before you apply for a position.`,
						)}
					</div>
					<FeedArticleList />
				</Grid>
			</Grid>
		</>
	)
}

export default memo(Index)
